import React, { useEffect, useMemo } from "react";
import { NavDropdown } from "react-bootstrap";
import { logout } from "service/utilities";
import styles from "./header.module.scss";
import sanchu_icon from "assets/images/sanchu_icon.jpg";
import notification from "assets/icons/notification.svg";
import user from "assets/icons/user.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotification } from "redux/action/notification";

const Header = () => {

  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.notification);

  const openNotification = () => {
    dispatch({
      type: "TOGGLE_NOTIFICATION",
      payload: {
        isOpen: true
      }
    });
  };

  useEffect(() => {
    getAllNotification(dispatch)
  }, []);

  const unReads = useMemo(() => {
    return notifications?.filter(a => a?.isRead == false)
  }, [notifications])

  return (
    <div>
      <div className={styles.headerBox}>
        <div className="d-flex align-items-baseline justify-content-between">
          <div>
            <img src={sanchu_icon} className={styles.icon} alt="Icon" />
          </div>
          <div className="d-flex align-items-center">
            <div className={styles.bellcontainer} onClick={openNotification}>
              <img
                src={notification}
                className="cursor-pointer"
                alt="notification"
              />
              <span className={styles.count}>{unReads?.length > 9 ? unReads?.length : "0" + unReads?.length}</span>
            </div>

            <img src={user} alt="profile" />
            <NavDropdown title="Admin" className={styles.navDropdown}>
              <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
